module.exports = __webpack_public_path__ + "static/media/71pC69I3lzL._AC_SL1500_.bec46d64.jpg";